import { useTranslation } from "react-i18next";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setModalsData, TModalsState } from "../../../api/store/commonSlice";
import svgIcons from "../../../assets/svg/svgIcons";
import { DeviceSnapshot } from "../../../api/types/Camera";

interface ShowSnapshotsProps {
  snapshots: DeviceSnapshot[] | [];
}

const ShowSnapshots = (props: ShowSnapshotsProps) => {
    const { t } = useTranslation("translation", {
        keyPrefix: "camera.dashboard.management.cameras",
      });
  const { snapshots } = props;

  const modalsState = useSelector(
    (state: { commonReducer: { modals: TModalsState } }) =>
      state.commonReducer.modals
  );

  const dispatch = useDispatch();

  const hideModal = () => {
    dispatch(setModalsData({ ...modalsState, showSnapShotsView: false }));
  };

  if (!modalsState.showSnapShotsView) {
    return null;
  }

  return (
    <>
      <div
        className="fixed w-full h-screen top-0 left-0 bg-modal-overlay z-overlay"
        onClick={hideModal}
      />
      <div
        className={
          "fixed inset-y-1/2 inset-x-1/2 w-full h-full pt-10 bg-black/80 overflow-hidden " +
          "Xbg-white rounded-xl shadow-lg z-modal"
        }
        style={{ transform: "translate(-50%, -50%)" }}
      >
        {/* Close button */}
        <div className="absolute top-12 right-4 flex flex-row gap-2 z-50 p-2 bg-white/20 rounded-full col-span-9">
          <button
            className="group size-10 flex items-center justify-center rounded-full bg-black hover:bg-gray-100 focus:ring focus:ring-white outline-0"
            onClick={hideModal}
          >
            <img
              src={svgIcons.CloseIcon}
              alt="Close"
              className="grayscale-0 brightness-0 invert group-hover:invert-0 opacity-50"
            />
          </button>
        </div>
        <div className="h-[calc(100vh-10rem)] overflow-auto mt-20 flex justify-center items-center w-full">
          {snapshots && snapshots.length > 0 ? (
            <img
              src={snapshots[0].url}
              alt="Snapshot"
              className="max-h-full max-w-full object-contain"
            />
          ) : (
            <div className="flex items-center justify-center w-full h-full text-white text-lg">
              {t("no_photo_available")}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ShowSnapshots;
